



















































































































import Vue from 'vue'
import { getModule } from 'vuex-module-decorators'
import { CompendiumStore } from '@/store'
import { MechSystem } from '@/class'
import { flavorID } from '@/io/Generators'
import { Bonus } from '@/classes/components/feature/bonus/Bonus'

export default Vue.extend({
  name: 'mod-selector',
  props: {
    weapon: {
      type: Object,
      required: true,
    },
    mech: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    headers: [
      { text: 'Source', align: 'left', value: 'Source' },
      { text: 'Mod', align: 'left', value: 'Name' },
      { text: 'License', align: 'left', value: 'LicenseString' },
      { text: 'SP', align: 'left', value: 'SP' },
      { text: '', align: 'center', value: 'Equip' },
    ],
    mods: [],
    showUnlicensed: false,
    showOverSP: false,
    showIncompatible: false,
  }),
  computed: {
    freeSP(): number {
      return this.weapon.Mod ? this.mech.FreeSP + this.weapon.Mod.SP : this.mech.FreeSP
    },
    availableMods(): MechSystem[] {
      let i = this.mods.filter(x => !x.IsHidden && !x.IsExotic)

      if (!this.showUnlicensed) {
        i = i.filter(
          x => !x.LicenseLevel || this.mech.Pilot.has('License', x.LicenseID, x.LicenseLevel)
        )
      }

      i = i.concat(this.mech.Pilot.SpecialEquipment.filter(x => x.ItemType === 'WeaponMod').filter(x => !i.map(y => y.ID).includes(x.ID)))
      i = i.concat(this.mech.MechLoadoutController.ActiveLoadout.SpecialEquipment.filter(x => x.ItemType === 'WeaponMod').filter(x => !i.map(y => y.ID).includes(x.ID)))

      if (!this.showIncompatible) {
        // filter by applied_to
        i = i.filter(x => x.AllowedTypes && x.AllowedTypes.includes(this.weapon.ModType))
        i = i.filter(x => x.AllowedSizes && x.AllowedSizes.includes(this.weapon.ModSize))

        // // filter out any mount restrictions
        i = i.filter(x => !x.RestrictedTypes || !x.RestrictedTypes.includes(this.weapon.ModType))
        i = i.filter(x => !x.RestrictedSizes || !x.RestrictedSizes.includes(this.weapon.ModSize))
      }

      // filter already equipped
      if (this.weapon.Mod) i = i.filter(x => x.ID !== this.weapon.Mod.ID)

      // filter unique
      i = i.filter(
        x => !this.mech.MechLoadoutController.ActiveLoadout.UniqueMods.map(y => y.ID).includes(x.ID)
      )

      // filter ai
      if (!this.showUnlicensed &&
        this.mech.MechLoadoutController.ActiveLoadout.AICount >=
        1 + Bonus.get('ai_cap', this.mech)
      ) {
        i = i.filter(x => !x.IsAI)
      }

      // if (!this.showOverSP) {
      //   i = i.filter(x => x.SP <= this.freeSP)
      // }

      return i
    },
  },
  created() {
    const compendium = getModule(CompendiumStore, this.$store)
    this.mods = compendium.WeaponMods.filter(x => x.Source)
  },
  methods: {
    fID(template: string): string {
      return flavorID(template)
    },
  },
})
